// extracted by mini-css-extract-plugin
export default {"banner":"QMtWn","blue":"DGq2l","darkBlue":"Ue_Z8","indigo":"PddrB","purple":"lBBF6","cyan":"YyeMy","message":"F04Kg","children":"hsXnh","close":"ie3b_","icon":"VfjGd"};